"use strict";

var _core = require("@emotion/core");

var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tabs = exports.Tab = void 0;

var React = __importStar(require("react")); // @ts-ignore


var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var foundation_1 = require("../../theme/foundation");

var utils_2 = require("../../utils");

var lseds_1 = require("../../lseds");

var core_1 = require("@emotion/core");

exports.Tab = utils_2.forwardRef(function Grid(props, ref) {
  var first = props.first,
      last = props.last,
      selected = props.selected,
      onClickAction = props.onClickAction,
      onTabChange = props.onTabChange,
      label = props.label,
      disabled = props.disabled,
      padding = props.padding;
  var tab = core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\t {\n\t\t\t", "\n\t\t\t", "\n\t\t\t", "\n\t\t\tborder-bottom: solid ", ";\n\t\t\tpadding: ", ";\n\t\t\tposition: relative;\n\t\t\tmargin-bottom: -1px;\n\t\t\tcolor: ", ";\n\t\t\tcursor: ", ";\n\t\t\ttransition: all 0.1s ease-in-out;\n\t\t\topacity: ", ";\n\n\t\t\t&:hover {\n\t\t\t\tcolor: ", ";\n\t\t\t\tborder-bottom: solid ", ";\n\t\t\t\ttransition: all 0.1s ease-in-out;\n\t\t\t}\n\t\t}\n\t"], ["\n\t\t {\n\t\t\t", "\n\t\t\t", "\n\t\t\t", "\n\t\t\tborder-bottom: solid ", ";\n\t\t\tpadding: ", ";\n\t\t\tposition: relative;\n\t\t\tmargin-bottom: -1px;\n\t\t\tcolor: ", ";\n\t\t\tcursor: ", ";\n\t\t\ttransition: all 0.1s ease-in-out;\n\t\t\topacity: ", ";\n\n\t\t\t&:hover {\n\t\t\t\tcolor: ", ";\n\t\t\t\tborder-bottom: solid ", ";\n\t\t\t\ttransition: all 0.1s ease-in-out;\n\t\t\t}\n\t\t}\n\t"])), first && 'border-top-left-radius: 4px;', last && 'border-top-right-radius: 4px;', !first && 'border-left: none;', selected ? "2px " + foundation_1.colors.primary.green : "1px " + foundation_1.colors.graphical.strokes, padding || "8px 16px", selected ? foundation_1.colors.primary.green : 'inherit', disabled ? 'not-allowed' : selected ? 'inherit' : 'pointer', disabled ? '.5' : '1', selected ? foundation_1.colors.primary.green : foundation_1.colors.secondary.darkGrey, !selected ? "1px " + foundation_1.colors.secondary.mediumGrey : "2px " + foundation_1.colors.primary.green);
  return (0, _core.jsx)(lseds_1.lseds.div, {
    ref: ref,
    css: tab,
    onClick: function onClick() {
      if (!disabled) {
        onTabChange && onTabChange();
        onClickAction && onClickAction();
      }
    }
  }, label);
});
exports.Tabs = utils_2.forwardRef(function Grid(props, ref) {
  var tabPosition = props.tabPosition,
      hideBorderLine = props.hideBorderLine,
      padding = props.padding;

  var _a = React.useState(-1),
      selectedIndex = _a[0],
      setSelectedIndex = _a[1];

  var tabsContainer = core_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t\t {\n\t\t\twidth: 100%;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t}\n\t"], ["\n\t\t {\n\t\t\twidth: 100%;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t}\n\t"])));
  var tabs = core_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t\t {\n\t\t\twidth: 100%;\n\t\t\tdisplay: inline-flex;\n\t\t\t", ";\n\t\t\t", ";\n\t\t\t", ";\n\t\t}\n\t"], ["\n\t\t {\n\t\t\twidth: 100%;\n\t\t\tdisplay: inline-flex;\n\t\t\t", ";\n\t\t\t", ";\n\t\t\t", ";\n\t\t}\n\t"])), tabPosition && tabPosition === 'left' && 'justify-content: flex-start;', tabPosition && tabPosition === 'center' && 'justify-content: center;', tabPosition && tabPosition === 'right' && 'justify-content: flex-end;');
  var tabContent = core_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\t\t {\n\t\t\twidth: 100%;\n\t\t\tpadding-top: 1em;\n\t\t}\n\t"], ["\n\t\t {\n\t\t\twidth: 100%;\n\t\t\tpadding-top: 1em;\n\t\t}\n\t"])));
  var tabLine = core_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\t\t {\n\t\t\twidth: 100%;\n\t\t\theight: 1px;\n\t\t\tbackground: ", ";\n\t\t}\n\t"], ["\n\t\t {\n\t\t\twidth: 100%;\n\t\t\theight: 1px;\n\t\t\tbackground: ", ";\n\t\t}\n\t"])), foundation_1.colors.graphical.strokes);
  return (0, _core.jsx)(lseds_1.lseds.div, {
    ref: ref,
    css: tabsContainer
  }, (0, _core.jsx)(lseds_1.lseds.div, {
    ref: ref,
    css: tabs
  }, React.Children.map(props.children, function (child, index) {
    return React.cloneElement(child, {
      first: index === 0,
      index: index,
      last: index === props.children.length - 1,
      selected: selectedIndex !== -1 ? selectedIndex === index : child.props.selected,
      disabled: child.props.disabled,
      padding: padding,
      onClickAction: function onClickAction() {
        return setSelectedIndex(index);
      }
    });
  })), !hideBorderLine && (0, _core.jsx)(lseds_1.lseds.div, {
    css: tabLine
  }), (0, _core.jsx)(lseds_1.lseds.div, {
    ref: ref,
    css: tabContent
  }, React.Children.map(props.children, function (child, index) {
    if (selectedIndex !== -1 ? selectedIndex === index : child.props.selected) {
      return child.props.children;
    }
  })));
});

if (utils_1.isDev) {
  exports.Tabs.displayName = 'Tabs';
}

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;